module.exports = __webpack_public_path__ + "static/ibarra-tree-ce9b7e540bec647204d2f925cf991c06.jpg";